import { SkeletonRectangle } from '@wix/design-system';
import s from '../AgencyProfileHeader.module.scss';

const SkeletonLoggingInArea = () => {
  return (
    <li className={`${s.cell} ${s.desktop} ${s.right} ${s.last}`}>
      <SkeletonRectangle height={'12px'} width={'72px'} />
    </li>
  );
};

export default SkeletonLoggingInArea;
